module.exports = __webpack_public_path__ + "static/media/tupe.ab248e58.webp";